"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdminSelector = exports.isManagerSelector = exports.getUserRoleSelector = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("../constants/constants");
var client_1 = require("../api/client");
// the client record is a cache entry now, so this reads it through the endpoint's own selector
var getClient = function (state) { var _a, _b; return client_1.clientApi.endpoints.getClient.select((_b = (_a = state.userState.user) === null || _a === void 0 ? void 0 : _a.client_id) !== null && _b !== void 0 ? _b : "")(state).data; };
var getUserState = function (state) { return state.userState; };
var getUserRoleSelector = (0, toolkit_1.createSelector)([getClient, getUserState], function (client, _a) {
    var _b, _c;
    var user = _a.user;
    var manager_of = ((_c = (_b = client === null || client === void 0 ? void 0 : client.users) === null || _b === void 0 ? void 0 : _b.find(function (clientUser) { return clientUser.user_id === user._id; })) !== null && _c !== void 0 ? _c : {}).manager_of;
    var role = user.role;
    return { role: role, manager_of: manager_of };
});
exports.getUserRoleSelector = getUserRoleSelector;
var isManagerSelector = (0, toolkit_1.createSelector)(getUserRoleSelector, function (_a) {
    var role = _a.role, manager_of = _a.manager_of;
    var isManager = role === constants_1.BRANCH_MANAGER || role === constants_1.AREA_MANAGER;
    var managedBanches = manager_of;
    return { isManager: isManager, managedBanches: managedBanches };
});
exports.isManagerSelector = isManagerSelector;
var isAdminSelector = (0, toolkit_1.createSelector)(getUserRoleSelector, function (_a) {
    var role = _a.role;
    return role === constants_1.ADMIN;
});
exports.isAdminSelector = isAdminSelector;
